import { render, staticRenderFns } from "./UserCalendar.vue?vue&type=template&id=35da7231"
import script from "./UserCalendar.vue?vue&type=script&lang=js"
export * from "./UserCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports